// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"440":"1aa0ddac49ee9910","581":"7adbfe597e672e0c","768":"c742b1754b9ea7e8"}[chunkId] + ".js";
};